import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t, lang, localizePath } = useI18n();
  const tagline = lang === "en"
    ? "We design Mediterranean yacht holidays around you — tailor-made, curated by experts. Your concierge takes care of everything, from itinerary to boarding."
    : "Costruiamo la vacanza in barca attorno a te — non il contrario. Riceverai le proposte più adatte via email e WhatsApp, con alternative intelligenti se nessuna soluzione è perfetta.";
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_charter-connect-beta/artifacts/9lb67pg5_logo%20seamatch.png"
              alt="Seamatch"
              className="h-12 w-12 rounded-full object-cover"
            />
            <span className="font-serif text-2xl">Seamatch</span>
          </div>
          <p className="mt-4 text-sm text-white/70 max-w-md leading-relaxed">{tagline}</p>
          <p className="mt-3 text-[11px] uppercase tracking-wider text-gold/80">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <p className="label-eyebrow text-gold mb-3">{lang === "en" ? "Explore" : "Esplora"}</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to={localizePath("/come-funziona")} className="hover:text-white">{t("footer.howItWorks")}</Link></li>
            <li><Link to={localizePath("/destinazioni")} data-testid="footer-link-destinations" className="hover:text-white">{lang === "en" ? "Destinations" : "Destinazioni"}</Link></li>
            <li><Link to={localizePath("/search")} className="hover:text-white">{t("footer.findBoat")}</Link></li>
            <li><Link to={localizePath("/centro-aiuto")} data-testid="footer-link-centro-aiuto" className="hover:text-white">{t("footer.help")}</Link></li>
            <li><Link to={localizePath("/contatti")} className="hover:text-white">{t("footer.contact")}</Link></li>
            <li><Link to={localizePath("/privacy-policy")} data-testid="footer-link-privacy" className="hover:text-white">{t("footer.privacy")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-eyebrow text-gold mb-3">{t("footer.contact")}</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="mailto:info@seamatch.pro" className="hover:text-white">info@seamatch.pro</a></li>
            <li>WhatsApp +39 02 0000 0000</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 flex flex-col md:flex-row justify-between gap-2 text-xs text-white/50">
          <span>{t("footer.copy")}</span>
          <span>{lang === "en" ? "Made with care for the Mediterranean." : "Fatto con cura per il Mediterraneo."}</span>
        </div>
      </div>
    </footer>
  );
}
